/**
 * Utility functions for number handling across different locales
 */

/**
 * Normalizes decimal input from European locales (comma) to standard format (period)
 * This ensures Spanish and French users can input "10,5" and it becomes "10.5"
 * 
 * @param {string} value - The input value from user
 * @returns {string} - Normalized value with period as decimal separator
 */
export const normalizeDecimalInput = (value) => {
  if (!value) return value;
  
  // Replace comma with period for ES/FR locales
  return value.toString().replace(',', '.');
};

/**
 * Parses a decimal value safely, handling both comma and period separators
 * 
 * @param {string|number} value - The value to parse
 * @returns {number} - Parsed float or 0 if invalid
 */
export const parseDecimalSafe = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  
  const normalized = normalizeDecimalInput(value);
  const parsed = parseFloat(normalized);
  
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Formats a number to a specific decimal precision
 * 
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - Formatted number string
 */
export const formatDecimal = (value, decimals = 2) => {
  const num = parseDecimalSafe(value);
  return num.toFixed(decimals);
};
